/* eslint-disable @typescript-eslint/explicit-function-return-type */
import * as React from 'react'
import { view } from 'react-easy-state'
import { useTranslation } from 'react-i18next'
import liff from '@line/liff'
import { Box, Image } from '@chakra-ui/react'
import ButtonChakra from '../../components/generics/ButtonChakra'

export default view(() => {
  const { t } = useTranslation()
  const isDisable = false

  return (
    <>
      <section className="duplicate-alert">
        <div id="alertDv-claim">
          <Box height="auto" display="flex" justifyContent="center">
            <Image boxSize="100px" src={t('viriyah.make-claim-success-page.logo')} alt="make-claim-success" />
          </Box>
          <div id="title">{t('viriyah.make-claim-success-page.title')}</div>
          <div
            id="description"
            dangerouslySetInnerHTML={{ __html: t('viriyah.make-claim-success-page.description') }}
          />
        </div>

        <div className="bottom-section">
          <ButtonChakra
            customBgColor="#0033A2"
            textColor="white"
            isDisable={isDisable}
            onClick={() => liff.closeWindow()}
          >
            {t('viriyah.make-claim-success-page.btn')}
          </ButtonChakra>
        </div>
      </section>
    </>
  )
})
